import React, { useEffect, useMemo } from 'react';
import { ThemeProvider } from '@emotion/react';
import { ThemeProvider as MUIThemeProvider } from '@mui/material/styles';
import { useFacility } from '../context/FacilityContext';
import {
  applyFacilityCssVars,
  getEmotionTheme,
  getMuiTheme
} from './facilityThemes';
import GlobalStyles from './GlobalStyles';

/**
 * Swaps Emotion + MUI themes and document CSS vars when the facility toggle changes,
 * so the whole app (not just the navbar) follows Central vs Strawberry Patch aesthetics.
 */
export default function FacilityThemeProviders({ children }) {
  const { facilityId } = useFacility();

  const emotionTheme = useMemo(() => getEmotionTheme(facilityId), [facilityId]);
  const muiTheme = useMemo(() => getMuiTheme(facilityId), [facilityId]);

  useEffect(() => {
    applyFacilityCssVars(facilityId);
  }, [facilityId]);

  return (
    <MUIThemeProvider theme={muiTheme}>
      <ThemeProvider theme={emotionTheme}>
        <GlobalStyles />
        {children}
      </ThemeProvider>
    </MUIThemeProvider>
  );
}
